
export default {
  head() {
    return {
      title: "Agence Google Ads | SEA à Dunkerque dès 290€/mois - ALEO AGENCY",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "ALEO, agence Google Ads à Dunkerque certifiée Google Partner, accompagne les entreprises dunkerquoises pour accroître leur visibilité en ligne et générer davantage de prospects.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Agence Google Ads à Dunkerque dès 290€/mois - ALEO AGENCY",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "ALEO, agence Google Ads à Dunkerque certifiée Google Partner, accompagne les entreprises dunkerquoises pour accroître leur visibilité en ligne et générer davantage de prospects.",
        },
      ],
    };
  },
};
